import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import React from 'react';
import { Layout } from './Layout';
import metaOverrides from './metaOverrides';


const UpgradeConfirmationPageTemplate = ({ resource }) => {
  return (
    <MetaResourceRenderer
      layout={Layout}
      resource={resource}
      metaOverrideSet={metaOverrides}
    />
  );
};

export { UpgradeConfirmationPageTemplate };
